"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const BaggageSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0.666504C10.368 0.666504 10.6667 0.965171 10.6667 1.33317V4.6665H11.3333V3.99984H12.6667V4.6665H13.3333C13.7013 4.6665 14 4.96517 14 5.33317V13.3332C14 13.7012 13.7013 13.9998 13.3333 13.9998H12.6667V14.6665H11.3333V13.9998H4.66667V14.6665H3.33333V13.9998H2.66667C2.29867 13.9998 2 13.7012 2 13.3332V5.33317C2 4.96517 2.29867 4.6665 2.66667 4.6665H3.33333V3.99984H4.66667V4.6665H5.33333V1.33317C5.33333 0.965171 5.632 0.666504 6 0.666504H10ZM12.6667 5.99984H3.33333V12.6665H12.6667V5.99984ZM6 6.6665V11.9998H4.66667V6.6665H6ZM8.66667 6.6665V11.9998H7.33333V6.6665H8.66667ZM11.3333 6.6665V11.9998H10V6.6665H11.3333ZM9.33333 1.99984H6.66667V4.6665H9.33333V1.99984Z" fill="currentColor" />
  </svg>
)

const BaggageIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BaggageSvg} {...props} />
);

export default BaggageIcon